export default __webpack_public_path__ + "assets/Oddscraft_Logo.png";